<mat-card>
  <mat-card-content>
    <div class="flex flex-col items-stretch">
      <div
        class="flex flex-col items-stretch md:flex-row justify-center md:space-x-2"
        [formGroup]="form"
      >
        <mat-form-field
          class="md:w-1/2"
          [testId]="testIds.WORKSHOP_SEARCH_FILTER"
        >
          <mat-label>Search customer / equipment</mat-label>
          <input matInput formControlName="search" />
        </mat-form-field>
        <mat-form-field
          class="md:w-1/2"
          [testId]="testIds.WORKSHOP_STATUS_DROPDOWN_FILTER"
        >
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option
              *ngFor="let status of availableStatuses$ | async"
              [value]="status.value"
            >
              {{ status.value | workshopJobStatusLabel }} ({{
                status.jobCount
              }})
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          class="md:w-1/2"
          [testId]="testIds.CUSTOMER_TYPE_DROPDOWN_FILTER"
        >
          <mat-label>External / Internal</mat-label>
          <mat-select formControlName="customer">
            <mat-option value="both"> Both</mat-option>
            <mat-option value="external"> External only</mat-option>
            <mat-option value="internal"> Internal only</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
